import React from 'react';
import { Link } from 'carbon-components-react';
import { useHistory } from 'react-router-dom';
import { APP_URL } from 'types';

const RegistrationHero: React.FC = () => {
  const history = useHistory();
  return (
    <div className="registration-hero">
      <h1 className="registration-title">Registration</h1>
      <p className="registration-subtitle">
        Already have an account?
        <Link onClick={() => history.push(APP_URL.LOGIN)}> Login here</Link>
      </p>
    </div>
  );
};

export default React.memo(RegistrationHero);
